import { CompetenciesTable } from "@/components/competencies/CompetenciesTable";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

export function CompetenciesPage() {
  useSetBreadcrumbs([{ label: "Capability" }, { label: "Competencies" }]);

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Capability"
        title="Competencies"
        description="Qualitative capabilities that role expectations can reference."
      />
      <CompetenciesTable />
    </div>
  );
}
